import React from "react"
import { Box, Container, Flex, Grid, Heading } from "theme-ui"
import RichContentStructuredText from "../richContentStructuredText"

const ContactSection = ({ data }) => {
  console.log("DATA", data)
  return (
    <Box
      sx={{
        py: [6, 8],
        backgroundColor: "darkGrey",
      }}
    >
      <Container>
        <Grid columns={[1, 1, 2]} gap={[32, 64]}>
          <Box>
            <Heading
              as="h2"
              variant="h2"
              sx={{
                fontWeight: "400",
                color: "dark",
                fontSize: [4, 5],
                my: [0, 0],
              }}
            >
              {data.title}
            </Heading>
          </Box>
          <Box sx={{ p: { fontSize: [3] } }}>
            {data.subtitle && (
              <Heading
                color="dark"
                as="h2"
                variant="h3"
                sx={{
                  mt: [0, 0],
                  fontWeight: "300",
                  pb: [3],
                }}
              >
                {data.subtitle}
              </Heading>
            )}
            <RichContentStructuredText text={data.body} />
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default ContactSection
